import { HTMLTooltipComponent } from "../controlWC/TooltipComponent"

export function _ShowTemporalTooltip(container: TSelectionHTML, message: string, durationMs = 2000) {
    const t = container.append<HTMLTooltipComponent>("wc-tooltip")
        .attr("position", "right")
        .style("display", "table-row")
        .text(message).node()
    t._Visible = true
    setTimeout(() => t.remove(), durationMs)
}